import { jsx as e } from "react/jsx-runtime";
import { useMemo as t, useCallback as a } from "react";
import r from "dayjs";
import { styled as n } from "@mui/joy";
import { DateCalendar as o } from "@mui/x-date-pickers";
import { useKendoDatePicker as i } from "../KendoDatePickerProvider.js";
const l = n(o)(({ theme: e2 }) => `
    background-color: ${e2.palette.isDarkMode ? e2.palette.neutral[150] : "var(--joy-palette-background-surface)"};
    color: ${e2.palette.isDarkMode ? e2.palette.neutral[500] : "inherit"};

    .MuiPickersCalendarHeader-root {
      color: ${e2.palette.isDarkMode ? e2.palette.neutral[400] : "inherit"};
    }

    .MuiPickersCalendarHeader-label,
    .MuiPickersCalendarHeader-switchViewButton {
      color: ${e2.palette.isDarkMode ? e2.palette.neutral[400] : "inherit"};
    }

    .MuiSvgIcon-root {
      fill: ${e2.palette.isDarkMode ? e2.palette.neutral[400] : "inherit"};
    }

    .MuiDayCalendar-weekDayLabel {
      color: ${e2.palette.isDarkMode ? e2.palette.neutral[400] : "inherit"};
    }

    .MuiPickersDay-root {
      color: ${e2.palette.isDarkMode ? e2.palette.neutral[500] : "inherit"};
    }

    .MuiPickersDay-root.Mui-selected {
      background-color: ${e2.palette.primary[500]};
      color: #fff;
    }
  `), u = ({ value: n2, onChange: o2 = () => {
}, disabled: u2, min: d, max: s }) => {
  const { views: c } = i(), p = t(() => n2 ? r(n2) : null, [n2]), m = t(() => d ? r(d) : null, [d]), k = t(() => s ? r(s) : null, [s]), D = a((e2, t2) => {
    "finish" === t2 && o2({ value: e2.toDate() });
  }, [o2]);
  return e(l, { defaultValue: p, minDate: m, maxDate: k, onChange: D, disabled: u2, views: c });
};
export {
  l as StyledDateCalendar,
  u as default
};
//# sourceMappingURL=CustomCalendar.js.map
